"use client";

import { useEffect } from "react";
import { migrateStorageKeys } from "@/lib/storage-keys";

/**
 * StorageMigration component
 *
 * Runs storage key migration on app startup to convert legacy keys
 * to the new secure naming format. This is a one-time operation per device.
 *
 * This component renders nothing (null) - it's purely for side effects.
 */
export function StorageMigration() {
  useEffect(() => {
    // Run migration on app startup
    // This is safe to call multiple times - it checks for existing data
    const result = migrateStorageKeys();

    // Log migration results in development
    if (process.env.NODE_ENV === "development" && result.migrated > 0) {
      console.log(`[StorageMigration] Migrated ${result.migrated} keys`);
    }
  }, []);

  // This component renders nothing
  return null;
}
